var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-tooltip',{ref:"tooltip",attrs:{"options":_vm.options}},[_c('div',{staticClass:"label-text",style:(_vm.cssColor)},[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }